export const Utils = {
  formatNumber: (iNumber, maxToFormat = 100000000) => {
    if (isNaN(iNumber)) return 0;
    if (iNumber > maxToFormat) {
      return new Intl.NumberFormat("vi-VN", {
        notation: "compact",
        compactDisplay: "short",
      }).format(iNumber);
    }
    return new Intl.NumberFormat("vi-VN").format(iNumber);
  },

  fileSizeInMB: (sizeInBytes) => {
    const sizeInMB = (sizeInBytes / (1024 * 1024)).toFixed(2);
    return sizeInMB;
  },

  getFullUrl: (url, isAvatar = true) => {
    if (url && !url.startsWith("http") && !url.startsWith("blob")) {
      return `${process.env.REACT_APP_BASE_URL}${encodeURI(url)}`;
    } else if (!url && isAvatar) {
      return AppResource.images.imgDefaultAvatar;
    } else if (!url && !isAvatar) {
      return AppResource.images.imgDefaultImage;
    }
    return encodeURI(url);
  },

  openInNewTab: (url) => {
    window.open(url, "_blank").focus();
  },
};
